<template>
  <b-table
    :items="turmas"
    :fields="fields"
    show-empty
    :empty-text="$t('GERAL.NENHUM_REGISTRO')"
    head-variant="light"
    responsive
    striped
    hover
    @sort-changed="aoMudarOrdenacao"
  >
    <template #cell(acoes)="item">
      <div class="flex">
        <b-dropdown variant="outline-default" v-if="podeEditar || podeExcluir">
          <b-dropdown-item @click="editar(item.item)" v-if="podeEditar">
            {{ $t('GERAL.EDITAR') }}
          </b-dropdown-item>
          <b-dropdown-item @click="excluir(item.item.id)" v-if="podeExcluir">
            {{ $t('GERAL.EXCLUIR') }}
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </template>
  </b-table>
</template>
<script>
import rotas from '@/common/utils/rotas';
import helpers from '@/common/utils/helpers';
import Permissoes from '@/components/mixins/permissoes';

export default {
  mixins: [Permissoes],
  props: {
    turmas: {
      type: Array,
      default: Array,
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'descricao',
          label: 'Nome',
          sortable: true,
        },
        {
          key: 'cargaHoraria',
          label: 'Carga Horária',
          sortable: true,
        },
        {
          key: 'vagas',
          label: 'Vagas',
          sortable: true,
        },
        {
          key: 'acoes',
          label: 'Ações',
        },
      ],
    };
  },
  methods: {
    editar(item) {
      this.$emit('editar', 'turma', item);
    },
    excluir(item) {
      this.$emit('excluir', item);
    },
    irPara(rota, id) {
      rotas.irPara(rota, id);
    },
    aoMudarOrdenacao({ sortBy, sortDesc }) {
      let campoOrdenado = helpers.primeiraLetraMaiuscula(sortBy)
      let ordem = sortDesc
      this.$emit('alterar-ordenacao', campoOrdenado, ordem);
    },
  },
};
</script>
